module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av593-d0a576d1fbe1595403e2e5102de37a04.jpg";